<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>It is so difficult to wait in graves</i>,</span></p>
<p class="ded3"><span><i>To watch the flowers at the lip</i>,</span></p>
<p class="ded3"><span><i>To sleep wide-eyed beneath the sky;</i></span></p>
<p class="ded3"><span><i>For centuries, to watch the stone</i>.</span></p>
<p class="ded3"><span><i>It is so difficult to wait</i>,</span></p>
<p class="ded4"><span><i>In your grave</i></span></p>
<p class="ded5"><span>—<i>Alone</i>.</span></p>
<p class="ded1"><span>Denton Welch 1940–41</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1b487f24